<div class="pia-sectionsBlock">
  <div class="pia-sectionBlock-header">
    <h1 class="truncate" title="{{ structure.name }}">{{ structure.name }}</h1>
    <a
      class="pia-icons pia-icon-close-big"
      [routerLink]="['/entries', 'structure']"
      title="{{ 'pia.sections.homepage_link' | translate }}"
    ></a>
  </div>

  <div class="pia-sectionBlock-body">
    @for (dataSection of data.sections; track dataSection) {
    <div>
      @if ([1, 2, 3].includes(dataSection.id)) {
      <div class="pia-sectionBlock-title">
        {{ dataSection.title | translate }}
        <hr />
      </div>
      @if (structure && section && item) {
      <ul class="pia-sectionBlock-list">
        @for (dataItem of dataSection?.items; track dataItem) { @if (
        !dataItem.hide && !['3.2', '3.3', '3.4', '3.5'].includes( dataSection.id
        + '.' + dataItem.id ) ) {
        <li>
          <a
            [routerLink]="[
              '/structures',
              structure.id,
              'section',
              dataSection.id,
              'item',
              dataItem.id
            ]"
            [ngClass]="{
              active: section.id == dataSection.id && item.id == dataItem.id
            }"
            class="truncate"
          >
            {{ dataItem.title | translate }}</a
          >
          <fa-icon
            [icon]="faSitemap"
            [ngClass]="{
              'pia-fa-valid':
                sidStatusService.structureStatus[
                  dataSection.id + '.' + dataItem.id
                ] === true
            }"
          ></fa-icon>
        </li>
        } }
      </ul>
      } }
    </div>
    }
  </div>
</div>
